import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Inicio', path: '/' },
    { label: 'Empresa', path: '/empresa' },
    { label: 'Servicios', path: '/servicios' },
    { label: 'FAQ', path: '/faq' },
    { label: 'Contacto', path: '/contacto' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/6bea04c8-eed4-4f8d-a07d-4399896150a0.png" 
              alt="VACIADOS MARIUS Logo" 
              className="h-12 w-auto"
              loading="eager"
              fetchpriority="high"
              width="48"
              height="48"
            />
            <span className="text-2xl font-bold text-gray-900">VM</span>
          </Link>

          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-teal-600'
                    : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-3">
            <a
              href="https://wa.me/34633759649"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 px-4 py-2 bg-green-600 text-white rounded-full text-sm font-medium hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill"></i>
              <span>633 759 649</span>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 cursor-pointer"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium cursor-pointer ${
                  location.pathname === item.path
                    ? 'text-teal-600'
                    : 'text-gray-700'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="pt-4 space-y-2">
              <a
                href="tel:+34936940041"
                className="flex items-center justify-center space-x-2 w-full px-4 py-3 bg-teal-600 text-white rounded-full text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                <span>936 94 00 41</span>
              </a>
              <a
                href="https://wa.me/34633759649"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center space-x-2 w-full px-4 py-3 bg-green-600 text-white rounded-full text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-fill"></i>
                <span>633 759 649</span>
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
